<template>
  <div>
    <!-- Cambia la imagen basada en el modo de tema -->
    <v-img 
      class="mx-auto my-6" 
      max-width="228" 
      :src="iconSrc" 
    ></v-img>
    <v-form @submit.prevent="login">
      <v-card class="mx-auto pa-12 pb-8" elevation="8" max-width="448" rounded="lg">
        <div class="text-subtitle-1 text-medium-emphasis">Email</div>

        <v-text-field 
          density="compact" 
          placeholder="Email address" 
          prepend-inner-icon="mdi-email-outline"  
          v-model="form.email"
          variant="outlined"
        ></v-text-field>

        <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
          Password
        </div>

        <v-text-field 
          :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'" 
          :type="visible ? 'text' : 'password'"  
          v-model="form.password"
          density="compact" 
          placeholder="Ingrese su Contraseña" 
          prepend-inner-icon="mdi-lock-outline" 
          variant="outlined"
          @click:append-inner="visible = !visible"
        ></v-text-field>

        <v-card class="mb-12" color="surface-variant" variant="tonal">
          <v-card-text class="text-medium-emphasis text-caption">
            Advertencia: Este portal es solo para personal autorizado por la Academia, si usted es Alumno deberá
            loguearse con las credenciales brindadas y el portal para el alumno.
          </v-card-text>
        </v-card>

        <v-btn 
          class="mb-8" 
          color="primary" 
          size="large" 
          variant="flat" 
          block 
          type="submit"
        >
          INGRESAR
        </v-btn>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { useTheme } from 'vuetify';

export default {
  data: () => ({
    visible: false,
    form: {
      email: '',
      password: ''
    },
    showPassword: false,
  }),
  computed: {
    // Computed property to return the correct icon based on the theme
    iconSrc() {
      const theme = useTheme();
      return theme.global.current.value.dark 
        ? require('@/assets/icondark.svg')  // Icon for dark mode
        : require('@/assets/icon.svg');     // Icon for light mode
    }
  },
  methods: {
    async login() {
      try {
        await this.$store.dispatch('login', this.form);
        await this.$router.push('/');
      } catch (e) {
        this.snackbar.status = 'error';
        this.snackbar.message = e.message;
      }
    }
  }
}
</script>
